import { Button, Card, Col, Container, Row } from "react-bootstrap";
import TowingCar from "../Images/towingCar.svg";
import Home from "../Images/home.png";
import CommercialBusiness from "../Images/CommercialBusinessInsurance.png";
import Avatar from "../Images/avatar.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PersonalInsurance.css";
import Truck from "../Images/truck.jpg";
import OfficePattern from "../Images/officePattern.jpg";
import { Briefcase, Building, ShieldCheck, Tools } from "react-bootstrap-icons";
import RianBotes from "../Images/rianbotes.png";
import ReactGA from "react-ga4";



export const CommercialInsurance = () => {
    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return (
        <>
            <Container
                fluid
                style={{
                    background: 'linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)',
                    color: '#ffffff',
                    padding: '4rem 2rem',
                    position: 'relative',
                    textAlign: 'center',
                    overflow: 'hidden',
                }}
            >
                {/* Optional Overlay for a polished effect */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 1,
                    }}
                />

                {/* Header Content */}
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
                        Commercial & Business Insurance
                    </h1>
                    <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', color: '#f0f0f0' }}>
                        Protect your business, assets, and future — with tailored coverage that grows with you.
                    </p>
                </div>
            </Container>
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <div
                            style={{
                                backgroundColor: '#ffffff',
                                padding: '3rem 2rem',
                                borderRadius: '20px',
                                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                            }}
                        >
                            <h2 style={{ fontSize: '2rem', fontWeight: '600', color: '#1e1e3f', textAlign: 'center', marginBottom: '2rem' }}>
                                Why Your Business Needs Commercial Insurance
                            </h2>
                            <Row className="text-center">
                                <Col md={6} lg={3} className="mb-4">
                                    <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                        <Briefcase />
                                    </div>
                                    <h5 style={{ fontWeight: '500' }}>Business Interruption</h5>
                                    <p style={{ fontSize: '0.95rem' }}>
                                        Protect your income in case your operations are halted due to unforeseen events like fire or theft.
                                    </p>
                                </Col>
                                <Col md={6} lg={3} className="mb-4">
                                    <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                        <ShieldCheck />
                                    </div>
                                    <h5 style={{ fontWeight: '500' }}>Liability Protection</h5>
                                    <p style={{ fontSize: '0.95rem' }}>
                                        Coverage against lawsuits and damages — including third-party injuries and property claims.
                                    </p>
                                </Col>
                                <Col md={6} lg={3} className="mb-4">
                                    <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                        <Building />
                                    </div>
                                    <h5 style={{ fontWeight: '500' }}>Property Coverage</h5>
                                    <p style={{ fontSize: '0.95rem' }}>
                                        Safeguard your building, equipment, and inventory from fire, theft, or natural disasters.
                                    </p>
                                </Col>
                                <Col md={6} lg={3} className="mb-4">
                                    <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                        <Tools />
                                    </div>
                                    <h5 style={{ fontWeight: '500' }}>Employee Protection</h5>
                                    <p style={{ fontSize: '0.95rem' }}>
                                        Ensure your team is covered with workers’ compensation and employer liability coverage.
                                    </p>
                                </Col>
                            </Row>
                            <div className="text-center mt-4">

                                <Card
                                    style={{
                                        borderRadius: '15px',
                                        boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
                                        padding: '2rem',
                                        textAlign: 'center',
                                        maxWidth: '400px',
                                        margin: '0 auto',
                                        width: '100%',
                                    }}
                                >
                                    <Card.Body>
                                        <div
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                margin: '0 auto',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            <img
                                                src={RianBotes}
                                                alt="Broker"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                        <h3 style={{ fontSize: '1.5rem', margin: '1rem 0 0.5rem 0', fontWeight: '600' }}>Rian Botes</h3>
                                        <p style={{ fontSize: '1rem', color: '#555' }}>Your personal guide for insurance solutions.</p>
                                        <p style={{ fontSize: '1rem', color: '#1e1e3f' }}>
                                            <FontAwesomeIcon icon={faPhone} /> <span style={{ whiteSpace: 'nowrap' }}>082 880 4219</span><br />
                                            <FontAwesomeIcon icon={faEnvelope} /> <span style={{ whiteSpace: 'nowrap' }}>info@logosbrokers.co.za</span>
                                        </p>
                                        <Button
                                            variant="primary"
                                            href="https://wa.me/828804219"
                                            style={{ marginTop: '1rem' }}
                                        >
                                            Message on WhatsApp
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <br />
        </>
    );
}
